class CustomTab extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.buttons = this.querySelectorAll('.tab-button');
    this.contents = this.querySelectorAll('.tab-content');

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.setActiveTab(index);
      });
    });

    this.preloadMedia();
  }

  setActiveTab(activeIndex) {
    this.stopAllVideos();

    this.buttons.forEach((button, index) => {
      const isActive = index === activeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      this.applyBaseOrActiveScheme(button);
    });

    this.contents.forEach((content, index) => {
      content.classList.toggle('is-active', index === activeIndex);
    });
  }

  applyBaseOrActiveScheme(button) {
    const baseScheme = button.dataset.baseScheme;
    const activeScheme = button.dataset.activeScheme;

    if (button.classList.contains('is-active')) {
      if (baseScheme) {
        button.classList.remove(baseScheme);
      }

      if (activeScheme) {
        button.classList.add(activeScheme);
      }

      return;
    }

    if (activeScheme) {
      button.classList.remove(activeScheme);
    }

    if (baseScheme) {
      button.classList.add(baseScheme);
    }
  }

  preloadMedia() {
    this.querySelectorAll('.tab-content img').forEach((img) => {
      if (img.complete) return;

      const preload = new Image();
      preload.src = img.currentSrc || img.src;

      if (img.srcset) {
        preload.srcset = img.srcset;
      }
    });

    this.querySelectorAll('.tab-content picture source').forEach((source) => {
      const srcset = source.getAttribute('srcset');
      if (!srcset) return;

      const preload = new Image();
      preload.src = srcset.split(',')[0].trim().split(/\s+/)[0];
    });

    this.querySelectorAll('.tab-content video').forEach((video) => {
      if (video.preload === 'none') return;
      video.load();
    });
  }

  stopAllVideos() {
    const videos = this.querySelectorAll('video');

    videos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.classList.remove('video-play');
    });
  }
}

customElements.define('custom-tab', CustomTab);
